import { createFileRoute } from "@tanstack/react-router";
import { ForFreelancersComponent } from "@/pages/for-freelancers";
import { head, loader } from "@/pages/for-freelancers.meta";

export const Route = createFileRoute("/$locale/for-freelancers")({
  loader,
  head,
  component: ForFreelancersComponent,
});
